export default {
  openSans: 'Open Sans',
  merriweather: 'Merriweather',
};
